import {useTranslation} from "react-i18next";
import React, {useEffect, useState} from "react";
import { Loader } from "../../loader/Loader";
import {buildSerieFromCollection} from "../../charts/utils";
import BlockTabs from "../../BlockTabs";
import DualAxisChart from "../../charts/DualAxisChart";
import Table from "../../tables/Table";
import useCustomTable from "../../tables/useCustomTable";

export default function StreamAnalytics(props) {
  const { t } = useTranslation();
  const [chartData, setChartData] = useState([]);
  const loaderProps = { success: props.isSuccess, error: props.isError, retry: props.retry }

  useEffect(() => {
    setChartData(formatChartData(props.stats))
  }, [props.stats])

  const formatChartData = (data) => {
    return [{
      name: "Events",
      data: buildSerieFromCollection({data, xAxisKey: 'date', yAxisKey: 'events'}),
      color: '#B2382B',
      visible: false,
      type: 'areaspline'
    },{
      name: "Monthly users",
      data: buildSerieFromCollection({data, xAxisKey: 'date', yAxisKey: 'monthly_users'}),
      color: '#FED3CF',
      visible: true,
      type: 'areaspline'
    },{
      name: "Daily users",
      data: buildSerieFromCollection({data, xAxisKey: 'date', yAxisKey: 'daily_users'}),
      color: '#FF513C',
      visible: true,
      type: 'areaspline'
    },{
      name: "Average daily users",
      data: buildSerieFromCollection({data, xAxisKey: 'date', yAxisKey: 'avg_daily_users'}),
      color: '#BBBBBB',
      visible: false,
      type: 'spline'
    },{
      name: "Events per user",
      data: buildSerieFromCollection({data, xAxisKey: 'date', yAxisKey: 'events_per_user'}),
      color: '#333333',
      visible: true,
      yAxis: 1,
      type: 'spline'
    }]
  };

  const columns = [{
    Header: 'Date',
    accessor: 'date',
    format: 'date'
  },{
    Header: t("analytics.table.events"),
    accessor: 'events',
    disableSortBy: true
  },{
    Header: t("analytics.table.daily_users"),
    accessor: 'daily_users',
    disableSortBy: true
  },{
    Header: t("analytics.table.events_per_user"),
    accessor: 'events_per_user',
    disableSortBy: true,
    // formatOptions: {digits: 2}
  },{
    Header: t("analytics.table.monthly_users"),
    accessor: 'monthly_users',
    disableSortBy: true
  },{
    Header: t("analytics.table.mtd_users"),
    accessor: 'mtd_users',
    disableSortBy: true
  },{
    Header: t("analytics.table.avg_daily_users"),
    accessor: 'avg_daily_users',
    disableSortBy: true
  }
  ]

  const {
    tableProps,
    paginationProps,
    tableSearchProps
  } = useCustomTable({
    sortable: true,
    paginate: true,
    sortBy: {date: 'desc'}
  })

  const customOption = {
    yAxis: [{
      gridLineWidth: 1,
      gridLineDashStyle: 'Dash',
      min: 0,
      minRange: 1,
      title: {
        text: ''
      },
      plotLines: [{
        value: 0,
        width: 1,
        color: '#808080'
      }]
    }, {
      title: {
        text: ''
      },
      labels: {
        formatter: function () {
            return this.value;
        }
      },
      opposite: true,
    }],
  }

  return (
    <BlockTabs title={t("analytics.dataByDay")} defaultActiveKey="chart">
      <Loader {...loaderProps} key="table" title="table">
        <Table data={props.stats} columns={columns} {...tableProps} />
      </Loader>
      <Loader {...loaderProps} key="chart" title="chart" >
        <DualAxisChart legendOptions={{clickable: true}} series={chartData} customOption={customOption}/>
      </Loader>
    </BlockTabs>
    )
}
